import store from '@/state';

export const showLoading = () => {
    store.commit('meta/SET_LOADING', true);
};

export const hideLoading = () => {
    store.commit('meta/SET_LOADING', false);
};

export const withLoading = async (asyncFunction) => {
    try {
        showLoading();
        const result = await asyncFunction();
        return result;
    } finally {
        hideLoading();
    }
};
